import { routes } from "@/consts";
import { useTranslate } from "@/locales";
import { useLocale } from "@/middleware";
import { LANG } from "@/types";
import { Link } from "react-router-dom";
import { CheckCircle, AlertCircle } from "lucide-react";

function getLevelStyle(level: string | boolean | undefined) {
  if (level === "0%") {
    return {
      border: "border-red-500",
      text: "text-red-500",
      icon: <AlertCircle className="w-6 h-6 text-red-500 mb-1" />,
      bg: "bg-red-50",
    };
  } else if (level === "50%") {
    return {
      border: "border-amber-400",
      text: "text-amber-500",
      icon: null,
      bg: "bg-amber-50",
    };
  } else {
    // 100% or false
    return {
      border: "border-green-500",
      text: "text-green-600",
      icon: <CheckCircle className="w-6 h-6 text-green-500 mb-1" />,
      bg: "bg-green-50",
    };
  }
}

function CompleteProfile({
  level,
  isCompany,
  isProfile,
}: {
  level?: string | boolean;
  isProfile: boolean;
  isCompany: boolean;
}) {
  const { locale } = useLocale();
  const { t } = useTranslate(locale);
  const style = getLevelStyle(level);
  return (
    <div
      dir={locale == LANG.AR ? "rtl" : "ltr"}
      className="my-2 bg-gradient-to-r from-purple-50 to-blue-50 font-bold flex flex-col md:flex-row items-center md:items-stretch justify-between px-3 md:px-8 py-4 md:py-6 rounded-2xl gap-4 md:gap-8"
    >
      {/* Progress Circle */}
      <div className="flex flex-col items-center justify-center min-w-16 md:min-w-24 min-h-16 md:min-h-24">
        <div
          className={`w-16 h-16 md:w-24 md:h-24 flex flex-col items-center justify-center rounded-full border-4 ${style.border} ${style.bg} shadow-sm transition-all duration-300`}
        >
          {style.icon}
          <span className={`font-extrabold text-lg md:text-2xl ${style.text}`}>
            {level === false ? "100%" : level}
          </span>
        </div>
      </div>
      {/* Info Section */}
      <div className="flex-1 flex flex-col items-center md:items-start text-center md:text-left gap-1 md:gap-2">
        <div className="text-lg md:text-2xl font-bold text-gray-900">
          {t("profile.completeProfile.title")}
        </div>
        <div className="font-medium text-sm md:text-base text-gray-800 mt-1 md:mt-2">
          {t("profile.completeProfile.des")}
        </div>
        <div className="font-medium text-xs md:text-base text-gray-800">
          {t("profile.completeProfile.subDes")}
        </div>
        <Link to={`${routes.settings}?tab=company`} className="underline text-red-500">
          {!isCompany && (
            <div className="text-red-500 mt-2 text-xs md:text-sm">
              - {t("profile.completeProfile.company")}
            </div>
          )}
        </Link>
        <Link to={routes.settings} className="underline text-red-500">
          {!isProfile && (
            <div className="mt-2 text-xs md:text-sm">
              - {t("profile.completeProfile.profile")}
            </div>
          )}
        </Link>
      </div>
    </div>
  );
}

export default CompleteProfile;
